// Skeleton loader sobrio para el detalle de caso.
// Institucional, sin animaciones agresivas, siguiendo la paleta PreventiApp.
import React from 'react';

function Bar({ width = 'w-32', height = 'h-3' }) {
  return <div className={`${width} ${height} rounded bg-[#EEF0FE] animate-pulse`} />;
}
function Block({ height = 'h-16', extra = '' }) {
  return <div className={`w-full ${height} rounded-xl bg-[#F4F7FE] animate-pulse ${extra}`} />;
}

export default function CaseDetailSkeleton() {
  return (
    <div className="space-y-5" data-testid="case-detail-skeleton">
      {/* Cabecera */}
      <div className="bg-white rounded-2xl border border-[#E5EAF5] p-5">
        <div className="flex flex-wrap items-center gap-2 mb-3">
          <Bar width="w-40" height="h-6" />
          <Bar width="w-24" height="h-6" />
          <Bar width="w-28" height="h-6" />
        </div>
        <Bar width="w-64" height="h-8" />
        <div className="mt-3">
          <Bar width="w-52" height="h-3" />
        </div>
        {/* Metadatos */}
        <div className="mt-5 grid grid-cols-2 md:grid-cols-4 gap-4">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i}>
              <Bar width="w-16" height="h-2.5" />
              <div className="mt-2">
                <Bar width="w-32" height="h-3.5" />
              </div>
            </div>
          ))}
        </div>
        {/* Factores */}
        <div className="mt-5 pt-4 border-t border-[#F1F3F9]">
          <Bar width="w-40" height="h-2.5" />
          <div className="mt-2 flex flex-wrap gap-1.5">
            {Array.from({ length: 4 }).map((_, i) => (
              <Bar key={i} width="w-24" height="h-5" />
            ))}
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
        {/* Timeline skeleton */}
        <div className="lg:col-span-2 bg-white rounded-2xl border border-[#E5EAF5] p-5 space-y-3">
          <Bar width="w-56" height="h-4" />
          <Bar width="w-40" height="h-3" />
          <div className="mt-4 space-y-4">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="flex gap-3">
                <div className="w-4 h-4 rounded-full bg-[#EEF0FE] animate-pulse mt-1" />
                <div className="flex-1 space-y-2">
                  <Bar width="w-1/2" height="h-4" />
                  <Bar width="w-3/4" height="h-3" />
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* Panel de acciones skeleton */}
        <div className="space-y-4">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="bg-white rounded-2xl border border-[#E5EAF5] p-4 space-y-3">
              <Bar width="w-40" height="h-4" />
              <Block height="h-9" />
              <Block height="h-9" />
            </div>
          ))}
        </div>
      </div>

      <div className="text-xs text-[#94A3B8] text-center" data-testid="skeleton-hint">
        Cargando caso… puede tomar unos segundos si es la primera consulta.
      </div>
    </div>
  );
}
